import { CreativeType } from 'core/creative/Creative';
import { ComboCreativeListDataProvider } from './ComboCreativeListDataProvider';
import { OneForAllVideoCreativeListDataProvider } from './OneForAllVideoCreativeListDataProvider';
import { HTML5CreativeListDataProvider } from './HTML5CreativeListDataProvider';
import { ImageCreativeListDataProvider } from './ImageCreativeListDataProvider';
import { NativeCreativeListDataProvider } from './NativeCreativeListDataProvider';
import { OneForAllCreativeListDataProvider } from './OneForAllCreativeListDataProvider';
import { PPSCreativeListDataProvider } from './PPSCreativeListDataProvider';
import { VideoCreativeListDataProvider } from './VideoCreativeListDataProvider';
import { CustomLayoutCreativeListDataProvider } from './CustomLayoutCreativeListDataProvider';
import { PICCreativeListDataProvider } from './PICCreativeListDataProvider';
import { SandboxOutdoorCreativeListDataProvider } from './SandboxOutdoorCreativeListDataProvider';
import { FridgeCreativeListDataProvider } from './FridgeCreativeListDataProvider';
import { LineMessageCreativeListDataProvider } from './LineMessageCreativeListDataProvider';
import { DynamicOutdoorCreativeListDataProvider } from './DynamicOutdoorCreativeListDataProvider';
import { HwacomCreativeListDataProvider } from './HwacomCreativeListDataProvider';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

export function getDataProvider(creativeType: CreativeType, model: any) {
  const isBeaconBannerType =
    ChannelGroupSetting.isBeaconBannerType(creativeType);
  if (isBeaconBannerType) {
    return new LineMessageCreativeListDataProvider(model);
  }
  switch (creativeType) {
    case CreativeType.NATIVE:
      return new NativeCreativeListDataProvider(model);
    case CreativeType.IMAGE:
      return new ImageCreativeListDataProvider(model);
    case CreativeType.VIDEO:
    case CreativeType.CTV:
      return new VideoCreativeListDataProvider(model);
    case CreativeType.ONE_FOR_ALL:
    case CreativeType.ONE_FOR_ALL_DISPLAY:
      return new OneForAllCreativeListDataProvider(model);
    case CreativeType.THIRD_PARTY:
      return new PPSCreativeListDataProvider(model);
    case CreativeType.HTML5:
      return new HTML5CreativeListDataProvider(model);
    case CreativeType.PIC_SHORT:
    case CreativeType.PIC_LONG:
    case CreativeType.PIC_EXTENDED:
    case CreativeType.PIC_BROAD:
      return new PICCreativeListDataProvider(model);
    case CreativeType.HWACOM_SHORT:
    case CreativeType.HWACOM_LONG:
    case CreativeType.HWACOM_EXTENDED:
    case CreativeType.HWACOM_BROAD:
      return new HwacomCreativeListDataProvider(model);
    case CreativeType.SANDBOX_OUTDOOR:
      return new SandboxOutdoorCreativeListDataProvider(model);
    case CreativeType.FRIDGE_LONG:
    case CreativeType.FRIDGE_EXTENDED:
    case CreativeType.FRIDGE_BROAD:
      return new FridgeCreativeListDataProvider(model);
    case CreativeType.OUTDOOR_LINE_MESSAGE:
      return new LineMessageCreativeListDataProvider(model);
    case CreativeType.LINE_MESSAGE:
      return new LineMessageCreativeListDataProvider(model);
    case CreativeType.COMBO:
      return new ComboCreativeListDataProvider(model);
    case CreativeType.ONE_FOR_ALL_VIDEO:
      return new OneForAllVideoCreativeListDataProvider(model);
    case CreativeType.CUSTOM_BOTTOM:
    case CreativeType.CUSTOM_RECTANGLE:
      return new CustomLayoutCreativeListDataProvider(model);
    default:
      return new DynamicOutdoorCreativeListDataProvider(model);
  }
}
